import { useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPasswordModal({ user: targetUser, onClose }) {
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/admin/users/${targetUser._id}/reset-password`, { new_password: password }, { withCredentials: true });
      toast.success(`Password reset for ${targetUser.email}`);
      onClose();
    } catch {
      toast.error("Failed to reset password");
    }
    setSubmitting(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div
        data-testid="reset-password-modal"
        className="w-full max-w-sm rounded-xl border-2 border-[var(--c-border)] bg-[var(--c-surface)] p-6 shadow-[6px_6px_0px_var(--c-shadow)]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-5 flex items-center justify-between">
          <h2 className="font-heading text-lg font-bold text-[var(--c-text)]">Reset Password</h2>
          <button onClick={onClose} className="text-[var(--c-muted)] hover:text-[var(--c-text)]"><X className="h-5 w-5" /></button>
        </div>
        <p className="mb-4 text-sm text-[var(--c-muted)]">Set a new password for <strong className="text-[var(--c-text)]">{targetUser.email}</strong></p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input data-testid="reset-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6}
            className="w-full rounded-lg border-2 border-[var(--c-border)] bg-[var(--c-surface)] px-4 py-2.5 text-sm text-[var(--c-text)] focus:border-[#1E3A8A] focus:outline-none" placeholder="New password (min 6 chars)" />
          <button data-testid="reset-password-submit" type="submit" disabled={submitting}
            className="flex w-full items-center justify-center rounded-full border-2 border-[var(--c-border)] bg-[#1E3A8A] px-5 py-2.5 font-bold text-white shadow-[3px_3px_0px_var(--c-shadow)] transition-all hover:-translate-y-0.5 disabled:opacity-50">
            {submitting ? "Resetting..." : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
}
